<template>
    <div class="container">
        <div v-for="(year, index) in years" :key="year.year" class="row">
            <div v-if="index === 0" class="col-12 col-sm-10 offset-sm-1">
                <emblem>{{ getTitle(year.year) }}</emblem>
            </div>
            <div v-if="index !== 0" class="col-12 col-sm-10 offset-sm-1">
                <emblem>{{ year.year }}</emblem>
            </div>
            <agenda
                :items="year.items"
                class="col-12 col-sm-10 offset-sm-1 agenda-overview__item"
            ></agenda>
        </div>
    </div>
</template>

<script>
import agenda from '@/components/agenda/agenda';
import emblem from '@/components/emblem';
import translationMixin from '@/mixins/translations';

export default {
    components: {
        agenda,
        emblem
    },
    mixins: [translationMixin],
    props: {
        years: {
            type: Array,
            default: () => []
        },
        title: {
            type: String,
            default: null
        }
    },
    methods: {
        getTitle(year) {
            return this.title ?? year;
        }
    }
};
</script>

<style lang="scss">
.agenda-overview__item {
    cursor: auto;
    display: block;
}

.agenda-overview__item .card__bottom {
    display: none;
}

.agenda-overview__item .card__text {
    flex-direction: column;
    display: block;

    @include media-breakpoint-up(md) {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
    }
}

.agenda-overview__item .card__text__top {
    flex: 50%;
}
</style>
